module.exports = __webpack_public_path__ + "static/media/big-final.33f9b213.svg";